import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from 'react';
import { isBKJChangeEventType } from '../../common.types.js';
import { BKJCheckboxDisplay, BKJCheckboxInput, BKJCheckboxLabel, BKJCheckboxWrapper, } from './BKJCheckbox.styled.js';
import { BKJCheck } from './src/BKJCheck.js';
export const BKJCheckbox = forwardRef((props, ref) => {
    const { value, variant = 'GreenSolid', label, disabled, className, name, onChange, readOnly, ...rest } = props;
    const [checked, setChecked] = useState(!!value);
    const handleChange = (event) => {
        if (!Array.isArray(event) && isBKJChangeEventType(event)) {
            if (onChange)
                onChange({
                    ...event,
                    target: { checked: event.target.checked, name, value: event.target.checked },
                });
            setChecked(!!event.target.checked);
        }
    };
    useEffect(() => {
        if (typeof value !== 'undefined')
            setChecked(value);
    }, [value]);
    return (_jsxs(BKJCheckboxWrapper, { className: className, children: [_jsx(BKJCheckboxInput, { ...rest, type: "checkbox", id: `checkbox-${name}-label`, "aria-labelledby": `checkbox-${name}-label`, disabled: disabled, checked: checked, onChange: readOnly ? () => null : handleChange, ref: ref, name: name, readOnly: readOnly }), _jsx(BKJCheckboxDisplay, { value: checked, disabled: disabled, variant: variant, children: _jsx(BKJCheck, { variant: variant, checked: checked, disabled: disabled }) }), _jsx(BKJCheckboxLabel, { label: label, role: "label", htmlFor: `checkbox-${name}-label`, children: label })] }));
});
//# sourceMappingURL=BKJCheckbox.js.map